import { DesignProp, GeneralProp } from "../PropCategories";

export const listStyleType = {
  prop: "style-attribute",
  name: "List Style Type",
  nameI18n: "builder_ui.prop_type.list_style_type",
  type: "select",
  defaultValue: "disc",
  category: [DesignProp, GeneralProp],
  options: [
    {
      label: "Disc",
      labelI18n: "builder_ui.prop_type.styles.list_style_type_options.disc",
      value: "disc",
    },
    {
      label: "Circle",
      labelI18n: "builder_ui.prop_type.styles.list_style_type_options.circle",
      value: "circle",
    },
    {
      label: "Square",
      labelI18n: "builder_ui.prop_type.styles.list_style_type_options.square",
      value: "square",
    },
    {
      label: "None",
      labelI18n: "builder_ui.prop_type.styles.list_style_type_options.none",
      value: "none",
    },
  ],
} as const;
